import { ScanFailureReason } from '@wix/a11y-wizard-common';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { panelStateAtom } from '../atoms/session-atoms';
import { useShowFailedAnalyzePagesModal } from '../components/modals/show-failed-analyze-pages-modal';
import { AnalysisState } from './rules-state';
import { useOnScanFinished } from './use-on-scan-finished';
export const useShowPasswordProtectedScanFailureModal = () => {
  const {
    groupsDataMap
  } = useAtomValue(panelStateAtom);
  const showFailedAnalyzePagesModal = useShowFailedAnalyzePagesModal();
  const showModalIfPasswordProtected = useCallback(() => {
    const shouldShowModal = Array.from(groupsDataMap.values()).some(_ref => {
      let {
        analysisState,
        failureReason
      } = _ref;
      return analysisState === AnalysisState.AnalyzeFailed && failureReason === ScanFailureReason.PAGE_ACCESS_DENIED;
    });
    if (shouldShowModal) {
      void showFailedAnalyzePagesModal({
        failureReason: ScanFailureReason.PAGE_ACCESS_DENIED
      });
    }
  }, [groupsDataMap, showFailedAnalyzePagesModal]);
  useOnScanFinished(showModalIfPasswordProtected);
};
//# sourceMappingURL=use-show-password-protected-scan-failure-modal.js.map